var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 14C29.3755 14 26 17.3755 26 21.5C26 22.3762 26.1602 23.2163 26.4394 24H22.5C21.673 24 21 23.327 21 22.5C21 21.673 21.673 21 22.5 21H24.0254C24.0804 19.945 24.3018 18.936 24.6738 18H22.5C20.1306 18 18.2037 19.8472 18.0332 22.1738C18.0102 22.281 17.9991 22.3904 18 22.5V25.5V49.5C18 51.9675 20.0325 54 22.5 54H49.5C51.9675 54 54 51.9675 54 49.5V28.5C54 26.1733 52.187 24.2549 49.9121 24.041C49.9638 23.7004 50 23.3543 50 23C50 19.1516 46.8484 16 43 16C41.7095 16 40.5021 16.3603 39.4609 16.9766C38.0885 15.172 35.9294 14 33.5 14ZM33.5 17C35.0788 17 36.4455 17.8118 37.248 19.0273C36.4627 20.1583 36 21.5274 36 23C36 23.3399 36.0323 23.6726 36.0801 24H29.7793C29.2927 23.2836 29 22.4349 29 21.5C29 18.9965 30.9965 17 33.5 17ZM43 19C45.2276 19 47 20.7724 47 23C47 23.3472 46.9531 23.6805 46.8691 24H39.1308C39.0469 23.6805 39 23.3472 39 23C39 20.7724 40.7724 19 43 19ZM21 27H49.5C50.3465 27 51 27.6535 51 28.5V49.5C51 50.3465 50.3465 51 49.5 51H22.5C21.6535 51 21 50.3465 21 49.5V27ZM45.5 36C44.8369 36 44.2011 36.2634 43.7322 36.7322C43.2634 37.2011 43 37.837 43 38.5C43 39.163 43.2634 39.7989 43.7322 40.2678C44.2011 40.7366 44.8369 41 45.5 41C46.163 41 46.7989 40.7366 47.2678 40.2678C47.7366 39.7989 48 39.163 48 38.5C48 37.837 47.7366 37.2011 47.2678 36.7322C46.7989 36.2634 46.163 36 45.5 36Z",
    fill: "#131313"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#131313",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraIcon);
export default __webpack_public_path__ + "static/media/extra-icon.53c09d3bd1058bd0c0214f31dfba2a8e.svg";
export { ForwardRef as ReactComponent };